export const EMPTY_DATE = {
  date: null,
};

export const getDateCell = (date: Date | null) => {
  if (!date) {
    return EMPTY_DATE;
  }

  return {
    date,
  };
};
